module.exports = __webpack_public_path__ + "img/Blazer2.21574896.png";